import React from "react"
import { Chip, FontIcon, IconButton } from "material-ui"
import autobind from "class-autobind"
import { IOvertimeRule, EOvertimeRuleType, EOTType } from "../../../models"
import AddOvertimeRuleDialog from "./AddOvertimeRuleDialog"
import strings from "../../../localization/strings"
import _ from "lodash"
import { EnumValues } from "enum-values"
import AccountStore from "../../../stores/AccountStore"
import { red500 } from "material-ui/styles/colors"

interface IProps {
    otType: EOTType
    overtimeRules: IOvertimeRule[]
    error: string
    handleChange(overtimeRules: IOvertimeRule[]): void
}
interface IState {
    openAddOvertimeRuleDialog: boolean
    editOvertimeRule: IOvertimeRule
}

export default class OvertimeRuleChip extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            openAddOvertimeRuleDialog: false,
            editOvertimeRule: null,
        }
        autobind(this)
    }

    render() {
        const enablePayTypePriority = this.props.overtimeRules && this.props.overtimeRules.filter(rule => rule.Type === EOvertimeRuleType.Daily || rule.Type === EOvertimeRuleType.ConsecutiveDay || rule.Type === EOvertimeRuleType.Bi_Weekly).length == 0

        return (
            <div>
                <div style={{ position: "relative", marginTop: 10 }}>
                    <span style={{ color: "rgba(0, 0, 0, 0.3)", fontSize: 13 }}>{strings.Overtime_Rules}</span>
                    {this.props.error &&
                        <span style={{ color: red500, fontSize: 11, marginLeft: 10 }}>{this.props.error}</span>
                    }
                    <div style={{ display: "flex", flexWrap: "wrap", marginTop: -5 }}>
                        {this.props.overtimeRules.map((overtimeRule, index) =>
                            <Chip
                                key={index}
                                style={{ marginTop: 10, marginRight: 5, height: 35 }}
                                onClick={() => this.setState({ openAddOvertimeRuleDialog: true, editOvertimeRule: overtimeRule })}
                                onRequestDelete={() => {
                                    const overtimeRules = _.cloneDeep(this.props.overtimeRules).filter(item => item.Id !== overtimeRule.Id)
                                    this.props.handleChange(overtimeRules)
                                }}
                            >
                                {`${strings[EnumValues.getNameFromValue(EOvertimeRuleType, overtimeRule.Type)]}: 
                  ${overtimeRule.ConsecutiveDaysSettings ? overtimeRule.ConsecutiveDaysSettings.DaysWorkedToTriggerOvertime : " "}  
                  ${![0, null].includes(overtimeRule.OvertimeHourThreshold) ? `${overtimeRule.OvertimeHourThreshold} ${strings.OvertimeHours}` : " "}  
                  ${AccountStore.getHideOT2() ?
                                        "" :
                                        ![0, null].includes(overtimeRule.DoubleOvertimeHourThreshold) ?
                                            `${overtimeRule.DoubleOvertimeHourThreshold} ${strings.DoubleOvertimeHours}` :
                                            ""
                                    }`
                                }
                            </Chip>
                        )}
                        <div style={{ height: 40, marginTop: 2, display: "inline-block" }}>
                            {!this.state.openAddOvertimeRuleDialog &&
                                EnumValues.getValues(EOvertimeRuleType)
                                    .filter(type => this.props.otType === EOTType.Bi_Weekly ? true : type !== EOvertimeRuleType.Bi_Weekly)
                                    .filter(type => this.props.overtimeRules.find(rule => rule.Type === type) === undefined).length > 0 &&
                                <IconButton data-intercom-target={"Btn-OpenAddOvertimeRuleDialog"} onTouchTap={() => this.setState({ openAddOvertimeRuleDialog: true })}>
                                    <FontIcon className="fa fa-plus-circle" />
                                </IconButton>
                            }
                        </div>
                    </div>
                </div>
                {this.state.openAddOvertimeRuleDialog &&
                    <AddOvertimeRuleDialog
                        otType={this.props.otType}
                        overtimeRules={this.props.overtimeRules}
                        editOvertimeRule={this.state.editOvertimeRule}
                        handleClose={() => this.setState({ openAddOvertimeRuleDialog: false, editOvertimeRule: null })}
                        handleAdd={overtimeRule => {
                            this.setState({ openAddOvertimeRuleDialog: false, editOvertimeRule: null })
                            const overtimeRules = _.cloneDeep(this.props.overtimeRules)
                            overtimeRules.push(overtimeRule)
                            this.props.handleChange(overtimeRules)
                        }}
                        handleUpdate={overtimeRule => {
                            this.setState({ openAddOvertimeRuleDialog: false, editOvertimeRule: null })
                            const overtimeRules = _.cloneDeep(this.props.overtimeRules)
                            let indexOfUpdateRule
                            overtimeRules.forEach((rule, index) => {
                                if (rule.Id === overtimeRule.Id)
                                    indexOfUpdateRule = index
                            })
                            overtimeRules[indexOfUpdateRule] = overtimeRule
                            this.props.handleChange(overtimeRules)
                        }}
                        enablePayTypePriority={enablePayTypePriority}
                    />
                }
            </div>
        )
    }
}